var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstagraminline = function SvgInstagraminline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / Socials"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Instagram",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.1 10.004c0-3.156 0-4.734.752-5.871A4.53 4.53 0 0 1 4.13 2.855c1.136-.752 2.715-.752 5.87-.752 3.157 0 4.735 0 5.872.752.507.336.942.77 1.278 1.278.752 1.137.752 2.715.752 5.871 0 3.156 0 4.734-.752 5.871a4.53 4.53 0 0 1-1.278 1.278c-1.137.752-2.715.752-5.871.752-3.156 0-4.734 0-5.871-.752a4.529 4.529 0 0 1-1.278-1.278C2.1 14.738 2.1 13.16 2.1 10.004Zm11.992 0a4.09 4.09 0 1 1-8.182 0 4.09 4.09 0 0 1 8.181 0ZM10 12.711a2.707 2.707 0 1 0 0-5.413 2.707 2.707 0 0 0 0 5.413Zm4.253-6.042a.961.961 0 1 0 0-1.922.961.961 0 0 0 0 1.922Z",
    fill: "#fff"
  }))));
};
export default SvgInstagraminline;